<script setup lang="ts"></script>
<template>
  <div>
    <div class="ml-2 py-2 md:mx-0 flex justify-between items-center">
      <UserInterfaceGenericSkeleton
        class="mb-2 mt-7"
        width-class="w-[50vw] md:w-[25vw]"
        height-class="h-6"
        rounded-class="rounded-md"
      />
      <div class="flex gap-1 items-center">
        <UserInterfaceGenericSkeleton
          width-class="w-[5vw]"
          height-class="h-6"
        />
        <UserInterfaceGenericSkeleton
          width-class="w-8"
          height-class="h-8"
          rounded-class="rounded-full"
        />
        <UserInterfaceGenericSkeleton
          width-class="w-8"
          height-class="h-8"
          rounded-class="rounded-full"
        />
      </div>
    </div>
    <div class="overflow-hidden">
      <div
        class="flex gap-2 md:gap-4 w-[calc(33vw*10)] sm:w-[calc(27vw*10)] md:w-[calc(20*10)] lg:w-[calc(14*10)] xl:w-[calc(10*10)]"
      >
        <div
          v-for="n in 10"
          :key="n"
          class="w-[33vw] sm:w-[27vw] md:w-[20vw] lg:w-[14vw] xl:w-[10vw]"
        >
          <UserInterfaceGenericSkeleton height-class="h-12" />
        </div>
      </div>
    </div>
  </div>
</template>
